import { render, staticRenderFns } from "./AddAccess.vue?vue&type=template&id=10ff4802&scoped=true"
import script from "./AddAccess.vue?vue&type=script&lang=js"
export * from "./AddAccess.vue?vue&type=script&lang=js"
import style0 from "./AddAccess.vue?vue&type=style&index=0&id=10ff4802&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ff4802",
  null
  
)

export default component.exports